import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import uiConfig from 'src/lib/ui/config';

export class BookDecoration extends View {
  constructor(opts: ViewOpts & { redBook?: boolean }) {
    super({ width: uiConfig.popups.buruburu.width, height: 1064, ...opts });

    // Book spine.
    const rings = opts.redBook ? 3 : 4;
    for (let i = 0; i < rings; i++) {
      const y = 120 + i * (1064 / rings);
      const style = {
        superview: this,
        width: opts.redBook ? 66 : 93,
        height: 41,
        x: opts.redBook ? -23 : -32,
        image: `assets/ui/family/banners/book_spine.png`,
      };

      new ImageScaleView({
        ...style,
        y,
      });

      new ImageScaleView({
        ...style,
        y: y + 41,
      });
    }

    // Bookmarks.
    new ImageScaleView({
      superview: this,
      width: 51,
      height: 92,
      x: 568,
      y: 100,
      image: 'assets/ui/family/banners/pink_bookmark.png',
      visible: !opts.redBook,
    });
    new ImageScaleView({
      superview: this,
      width: 65,
      height: 62,
      x: 40,
      y: 1061,
      image: `assets/ui/family/banners/${
        opts.redBook ? 'red' : 'blue'
      }_bookmark.png`,
    });
    new ImageScaleView({
      superview: this,
      width: 47,
      height: 55,
      x: 572,
      y: 900,
      image: 'assets/ui/family/banners/yellow_bookmark.png',
      visible: !opts.redBook,
    });
  }
}
